import React from "react";
import { AlertTriangle, X } from "lucide-react";

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-sky-900/40 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            ></div>

            {/* Modal */}
            <div className="relative bg-white rounded-3xl shadow-2xl border border-sky-100 w-full max-w-sm overflow-hidden transform transition-all animate-in fade-in zoom-in duration-300">
                <div className="p-1">
                    <div className="bg-sky-50/50 rounded-2xl p-6">
                        <div className="flex justify-between items-start mb-4">
                            <div className="w-12 h-12 bg-amber-100 rounded-2xl flex items-center justify-center text-amber-600">
                                <AlertTriangle size={24} />
                            </div>
                            <button
                                onClick={onClose}
                                className="p-2 hover:bg-sky-100 rounded-xl transition text-sky-400 hover:text-sky-600"
                            >
                                <X size={20} />
                            </button>
                        </div>

                        <h3 className="text-xl font-extrabold text-sky-900 mb-2">{title || "Confirm Action"}</h3>
                        <p className="text-sky-700/70 text-sm leading-relaxed mb-8">
                            {message || "Are you sure you want to proceed with this action?"}
                        </p>

                        <div className="flex gap-3">
                            <button
                                onClick={onClose}
                                className="flex-1 py-3 px-4 bg-white border border-sky-100 text-sky-600 font-bold rounded-xl hover:bg-sky-50 transition shadow-sm hover:shadow-md"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    onConfirm();
                                    onClose();
                                }}
                                className="flex-1 py-3 px-4 bg-gradient-to-r from-red-500 to-rose-600 text-white font-bold rounded-xl hover:from-red-600 hover:to-rose-700 transition shadow-lg shadow-red-500/20 active:scale-95"
                            >
                                {confirmText || "Confirm"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
